import React, { useEffect, useRef } from 'react';
import { ChevronDown, MapPin } from 'lucide-react';
import './Hero.css';

const HERO_IMG = 'https://customer-assets.emergentagent.com/job_tapalpa-local/artifacts/s3i5dzed_Dogos%20Portada.png';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/drx2byx3_Logo%20DTC.png';

export const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const scroll = window.scrollY;
        const bg = heroRef.current.querySelector('.hero-bg');
        if (bg) bg.style.transform = `translateY(${scroll * 0.3}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="hero" ref={heroRef} data-testid="hero-section">
      <div className="hero-bg" style={{ backgroundImage: `url(${HERO_IMG})` }} />
      <div className="hero-overlay" />
      <div className="hero-embers" />

      <nav className="hero-nav" data-testid="hero-nav">
        <img src={LOGO_URL} alt="Dogos El Tío Chepe" className="hero-nav-logo" />
        <div className="hero-nav-links">
          <a href="#productos">Menú</a>
          <a href="#experiencia">Nosotros</a>
          <a href="#promociones">Promociones</a>
          <a href="#galeria">Galería</a>
          <a href="#ubicacion">Ubicación</a>
        </div>
      </nav>

      <div className="hero-content">
        <img src={LOGO_URL} alt="Dogos El Tío Chepe" className="hero-floating-logo" data-testid="hero-logo" />
        <div className="hero-badge" data-testid="hero-badge">
          <MapPin size={14} />
          <span>Tapalpa, Jalisco</span>
        </div>
        <h1 className="hero-title" data-testid="hero-title">
          <span className="hero-title-line1">Donde el sabor</span>
          <span className="hero-title-line2">se vuelve <em>tradición</em></span>
        </h1>
        <p className="hero-subtitle">
          Dogos artesanales estilo Sonora con pan horneado, salchicha premium y los mejores toppings de Tapalpa
        </p>
        <div className="hero-actions">
          <a href="#ubicacion" className="hero-btn-primary" data-testid="hero-cta-btn">
            <span className="hero-btn-fire" />
            Visítanos
          </a>
          <a href="#productos" className="hero-btn-secondary" data-testid="hero-menu-btn">
            Ver Menú
          </a>
        </div>
        <div className="hero-price-flash" data-testid="hero-price">
          <span className="hero-price-from">desde</span>
          <span className="hero-price-amount">$50</span>
          <span className="hero-price-currency">MXN</span>
        </div>
      </div>

      <a href="#productos" className="hero-scroll" aria-label="Scroll down" data-testid="hero-scroll-btn">
        <ChevronDown size={24} />
      </a>
    </section>
  );
};

export default Hero;
